import UserAgent from "../../Utils/UserAgent";
import DesktopMacInstallBanner from "./DesktopMacInstallBanner";
import DesktopWindowsInstallBanner from "./DesktopWindowsInstallBanner";

const DesktopInstallBanner = () => {
  if (UserAgent.isMac()) {
    return <DesktopMacInstallBanner/>;
  }
  else {
    return <DesktopWindowsInstallBanner />;
  }
};

export default DesktopInstallBanner;